// Custom JS
// @import('./js/components/FILE')

jQuery(document).ready(function ($) {
  // Restrict input to digits only for fields with the class 'zip'
  $(".zip input").on("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "");
  });

  appendUTMParams();
});

/*
  Append URL UTM params to specified target links in elements with CSS class .lvl-append-utms
  and interactive map buttons
*/
function appendUTMParams() {
  const targetLinks = document.querySelectorAll('.lvl-append-utms a, .interactive-map__location-button');
  const sourceParams = new URLSearchParams(window.location.search);
  if (targetLinks.length > 0 && sourceParams.size > 0) {
    const utmParams = sourceParams.entries()
      .reduce((utms, [key, value]) => {
        if (!key.includes('utm_')) return utms;
        return {
          ...utms,
          [key]: value
        }
      }, {});
    
    targetLinks.forEach((link) => {
      const url = new URL(link.href);
      for (const key in utmParams) {
        url.searchParams.append(key, utmParams[key]);
      }
      link.href = url;
    });
  }
}

// function wireDownloadImage() {
//     let images = document.querySelectorAll('img');
//     images.forEach(image => {
//         // add img-fluid class to all images
//         image.classList.add('img-fluid');
//         if (image.src.includes('www.SOURCE.com')) {
//             image.addEventListener('click', function() {
//                 downloadImage(image.src);
//             });
//         }
//     });
// }
//
// // Using fetch
// async function downloadImage(imageSrc) {
//     const image = await fetch(imageSrc)
//     const imageBlog = await image.blob()
//     const imageURL = URL.createObjectURL(imageBlog)
//     const filename = imageSrc.split('/').pop()
//
//     const link = document.createElement('a')
//     link.href = imageURL
//     link.download = filename;
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
// }
//
// wireDownloadImage();
